import { useGrowthbook } from '@experience/core-hostapp-share-lib';
import { computed } from 'vue';

export interface SelectionExperimentConfig {
  baseTagSlug: string;
  tourTagSlug: string;
}

const exposureKey = 'tour_city_selection';

export const useCityToursSelectionsExperiment = () => {
  const gb = useGrowthbook();

  const featureValue = gb?.getFeatureValue(exposureKey, 0);
  const isUnusualRoutesExperiment = computed(() => featureValue === 1);
  const isNewSelectionExperiment = computed(() => featureValue === 2);

  const selectionExperimentConfig = computed<SelectionExperimentConfig | null>(() => {
    if (isUnusualRoutesExperiment.value) {
      return { baseTagSlug: 'neobyichnyie-marshrutyi', tourTagSlug: 'na-vyhodnye' };
    }

    if (isNewSelectionExperiment.value) {
      return { baseTagSlug: 'novye', tourTagSlug: 'na-vyhodnye' };
    }

    return null;
  });

  return {
    featureValue,
    isUnusualRoutesExperiment,
    isNewSelectionExperiment,
    selectionExperimentConfig,
  };
};
